import {
  FILTER_HOVER_BG_PRIMARY_20,
  FILTER_HOVER_BORDER_BORDER,
  FILTER_HOVER_TEXT_FOREGROUND,
} from '@/components/filters/filter-styles'
import { cn } from '@/lib/utils'

export type FilterValuePillProps = {
  label: string
  /** Live result count rendered after the label (e.g. “Lab report (3)”). */
  count?: number
  selected: boolean
  onSelect: () => void
  className?: string
}

/**
 * Always-visible selectable filter value — the discoverability affordance for
 * lists whose values double as scoped views (Health Records workflow/type
 * pills). Segmented-chip visual language: soft primary tint when selected.
 */
export function FilterValuePill({ label, count, selected, onSelect, className }: FilterValuePillProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(
        'inline-flex h-6.5 max-w-full items-center gap-1 rounded-[var(--radius-button)] px-2.5 text-xs focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
        'transition-[color,background-color,border-color,transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-none',
        'active:scale-[0.97] motion-reduce:active:scale-100',
        selected
          ? cn(
              'border border-primary/30 bg-primary/15 font-semibold text-primary',
              FILTER_HOVER_BG_PRIMARY_20,
            )
          : cn(
              'border border-border/70 text-muted-foreground',
              FILTER_HOVER_BORDER_BORDER,
              FILTER_HOVER_TEXT_FOREGROUND,
            ),
        className,
      )}
    >
      <span className="truncate">{label}</span>
      {typeof count === 'number' ? (
        <span className={cn('shrink-0 tabular-nums', selected ? 'text-primary/80' : 'text-muted-foreground/80')}>
          ({count})
        </span>
      ) : null}
    </button>
  )
}
